import { useQuery } from 'react-query';

import { request } from 'app/utils';
import { Button, ButtonIcon, Flex, Hr, Typography } from 'components';
import { useSchool } from 'features/school';
import { SurveyListResponseCollection } from 'features/surveys';
import { useState } from 'react';
import styled from 'styled-components';

const SurveysListWrapper = styled(Flex)`
  position: fixed;
  right: 0px;
  background: ${({ theme }) => theme.colors.dark_150};
  z-index: 1010;

  ${({ theme: { mediaQueries } }) => {
    return `
      width: 90%;
      height: calc(100vh - 60px);
      top: 60px;

      ${mediaQueries.desktop} {
        width: 500px;
        height: calc(100vh - 80px);
        top: 80px;
      }
    `;
  }}
`;

const SurveysList = () => {
  const { apiGatewayUrl } = useSchool();

  const [opened, setOpened] = useState(false);

  const { data: surveysList, isLoading } = useQuery(
    `surveys-list`,
    async () => {
      const response = await request<SurveyListResponseCollection>({
        url: `/api/v1/School/Surveys/List`,
        baseURL: apiGatewayUrl,
        method: 'GET',
      });

      return response.data;
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  if (!surveysList?.surveys?.length || isLoading) return <></>;

  return (
    <Flex bg={opened ? 'dark_150' : 'transparent'}>
      <ButtonIcon
        type="button"
        icon="commentQuestion"
        width={{ m: 60, d: 80 }}
        height={{ m: 60, d: 80 }}
        bg="transparent"
        color="primary_400"
        justifyContent="center"
        iconWidth={20}
        onClick={() => setOpened(!opened)}
        badge={surveysList?.surveys?.length}
      />

      {opened && (
        <SurveysListWrapper flexDirection="column">
          <Typography type="type5" color="white80" fontWeight="bold" p={4}>
            Pesquisas não respondidas
          </Typography>

          <Hr color="gray_600" m={0} />

          {surveysList?.surveys?.map((survey) => {
            return (
              <Flex key={`suvey-row-${survey.uuid}`} flexGrow={0} flexDirection="column">
                <Flex flexGrow={0} flexDirection="column" py={3} px={4}>
                  <a href={survey.accessUrl} target="_blank" rel="noreferrer">
                    <Typography as="div" color="white" type="type2" mb={2}>
                      {survey.name}
                    </Typography>

                    <Button height="auto" p={0} bg="transparent" color="primary_400">
                      Responder agora
                    </Button>
                  </a>
                </Flex>

                <Hr color="gray_600" mt={0} />
              </Flex>
            );
          })}
        </SurveysListWrapper>
      )}
    </Flex>
  );
};

export default SurveysList;
